export interface JobProgressProps {
  stage: string;
  percent?: number;
  message?: string;
}

export function JobProgress({ stage, percent = 0, message }: JobProgressProps) {
  const clamped = Math.max(0, Math.min(100, percent));
  return (
    <div role="status" aria-live="polite">
      <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: '0.35rem', fontSize: '0.875rem' }}>
        <span style={{ fontWeight: 600 }}>{stage}</span>
        {percent > 0 ? <span>{clamped}%</span> : null}
      </div>
      <div className="ui-progress" aria-hidden={percent <= 0}>
        <div className="ui-progress__bar" style={{ width: `${clamped}%` }} />
      </div>
      {message ? (
        <p style={{ margin: '0.5rem 0 0', fontSize: '0.875rem', color: 'var(--3ds-text-secondary)' }}>{message}</p>
      ) : null}
    </div>
  );
}
